import React, { Component } from "react";
import MyPATStep, { MyPATStepSubHeading, MyPATStepTitle } from "./MyPATStep";
import Progress from "../content-request/containers/CardData/CardDataTabs/ProgressBar";

import { createStyles, WithStyles, withStyles } from "@material-ui/core";
import { Theme, Typography } from "@material-ui/core";

import { StepProps } from "./types/Stepper";
import {
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Grid,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const styles = (theme: Theme) =>
createStyles({
  stepContainer: {
    width: "100%",
    backgroundColor: "#fff",
    borderRadius: "4px",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
    padding: "18px 24px",
    // marginTop: "10px"
  },
  lable: {
    fontSize: "1rem",
    color: "#333",
    fontWeight: 500,
  },
  value: {
    fontSize: "1rem",
    color: "#666",
    fontWeight: "normal",
  },
  top22:{
    top: 22,
    right: '-10px',
  },
  progressStyle: {
    marginRight: 30,
    "&>div:nth-of-type(1)": {
      display: "flex",
      alignItems: "center",
      "&>div:nth-of-type(1)": {
        minWidth: "85px",
        margin: "10px 5px",
      },
    },
  },
  details: {
    "&>div:nth-of-type(1)": {
      flexDirection: "column",
      marginTop: 18,
    },
  },
  FeedbackIcon:{
    position: "absolute",
    top:2,
    display: "flex",
    justifyContent: "flex-end",
    right:30,
    '& .count': {
      zIndex:9,
      borderRadius: "50%",
      position: "absolute",
      color: "#fff",
      backgroundColor: "#E60152",
      textAlign: "center",
      width:20,
      display: "flex",
      alignItems: "center",
      fontSize:10,
      fontWeight:600,
      height:20,
      justifyContent: "center",
      top:-4,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    }
  },
  fullWidth: {
    width: "100%",
    paddingTop: 10,
    // margin: "10px 0",
    '&::before':{
      backgroundColor: 'transparent'
    }
  },
  grayBG: {
    padding: 10,
    backgroundColor: "#FAFAFA",
    margin: "30px 0 0px 0",
    maxWidth: "100%",
  },
  titleText: {
    fontWeight: 600,
    fontSize:'1rem',
    display: 'flex',
    "& span": {
      color: "#666",
      fontWeight: 400,
    },
  },
  statusIconContainer: {
    marginRight: "5px",
    marginLeft: 9,
  },
  statusNotStarted: {
    color: "#f23c3c",
  },
  paddingLeft:{
    paddingLeft: '30px',
  },
  panelDetails:{
    flexDirection: 'column',
    padding: '0 0 24px'
  },
  paddingZero:{
    padding:0
  },
  marginB15:{
    marginBottom: 15,
  },
  minHeight14:{
    minHeight: 14,
  },
  displayGrid:{
    display: "grid",
    gridTemplateColumns: "16% 84%",
    gridGap: '5px',
  },
});

interface Props extends WithStyles<typeof styles>, StepProps {
  expanded?: boolean;
  onChange?: (expanded: boolean) => void;
  title: React.ReactNode;
  subHeading?: React.ReactNode;
  secondarySummary?: React.ReactNode;
  secondarySummaryExpansionHeading?:React.ReactNode;
  descriptionHeading?: React.ReactNode;
  description?: React.ReactNode;
  taskStatus?: React.ReactNode;
  isProgressReq?: boolean;
  totalCountProgress?: React.ReactNode;
  countProgress?: React.ReactNode;
  percentage?: React.ReactNode;
  secondarySummaryHeading?: React.ReactNode;
  overallDone?: boolean;
  onFeedbackClickFromCreator?: Function;
  totalUnresolvedFeedbackCount: number;
}

interface State {
  expanded: boolean;
}

class MyPATExpansionStep extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      expanded: props.expanded || false,
    };
    this.feedbackFromCreator = this.feedbackFromCreator.bind(this);
  }
  componentDidUpdate(prevProps: Props) {
    if (prevProps.expanded !== this.props.expanded) {
      this.setState({
        expanded: !!this.props.expanded,
      });
    }
  }
  handleChange = (_event: any, expanded: boolean) => {
    if (this.props.onChange) {
      this.props.onChange(expanded);
    } else {
      this.setState({
        expanded,
      });
    }
  };
  feedbackFromCreator(event: any) {
    event.stopPropagation();
    if(this.props.onFeedbackClickFromCreator){
      this.props.onFeedbackClickFromCreator();
    }
  }

  handleStatusString(status : String){
    let statusStr : String = "";
    if(status === "Pending"){
        statusStr = "Not Started Yet"
        return statusStr;
    } else {
      statusStr = status;
      return statusStr;
    }
  }
  render() {
    const {
      status,
      title,
      subHeading,
      children,
      secondarySummary,
      secondarySummaryExpansionHeading,
      descriptionHeading,
      description,
      classes,
      taskStatus,
      isProgressReq,
      countProgress,
      totalCountProgress,
      percentage,
      secondarySummaryHeading,
      overallDone,
      totalUnresolvedFeedbackCount
    } = this.props;
    const { expanded } = this.state;
    let statusStr = (status || '').replace(/ /g,'');
    statusStr = statusStr.toLowerCase();
    return (
      <ExpansionPanel
        expanded={expanded}
        onChange={this.handleChange}
        className={classes.fullWidth}
        classes={{root:classes.stepContainer, expanded: classes.marginB15}}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          className={classes.details}
          classes={{expandIcon: classes.top22,root:[classes.paddingZero, classes.minHeight14].join(' '), expanded: classes.minHeight14}}
        >
          <Grid container spacing={16}>
            <Grid xs={secondarySummaryExpansionHeading?6:3}>
              <Typography className={classes.titleText}>
                <span className={classes.statusIconContainer}>
                  <img
                     src={`/assets/svg/contentRequest/step-${statusStr}.svg`}
                     alt={statusStr}
                  />
                </span>
                {title}
              </Typography>
              <Grid>
              {subHeading && (
                <Typography className={classes.titleText}>
                 <span className={classes.paddingLeft}> {subHeading}</span>
                </Typography>
              )}
              </Grid>
            </Grid>
            <Grid xs={6}>
            {secondarySummary && (
              <Typography className={classes.titleText}>
                <span> {secondarySummaryHeading}:&nbsp;</span> {secondarySummary}
              </Typography>
            )}
            {
              secondarySummaryExpansionHeading && (
                <Typography className={classes.titleText}>
                {secondarySummaryExpansionHeading}
              </Typography>
              )
            }
            </Grid>
            <Grid xs={3}>
              <Grid container>
              {taskStatus && (
                <Grid item>
                <Typography
                  className={[classes.titleText, classes.statusNotStarted].join(
                    " "
                  )}
                >
                  <span>Status: </span>&nbsp; {this.handleStatusString(status)}
                </Typography>
                </Grid>
               )}

              {isProgressReq && !overallDone && (
              <Grid item className={classes.progressStyle}>
                <Progress
                  percentage={percentage}
                  count={countProgress}
                  totalCount={totalCountProgress}
                />
              </Grid>
            )}
              {overallDone && totalUnresolvedFeedbackCount > 0 && (
                  <Grid item onClick={(e) => this.feedbackFromCreator(e)}>                    
                    <Grid className={classes.FeedbackIcon}>
                      <span className="count">{totalUnresolvedFeedbackCount}</span>
                      <img alt="feedback" src="/assets/svg/contentRequest/feedback-Icon.svg" />
                    </Grid>
                  </Grid>
            )}
            </Grid>
            </Grid>
          </Grid>
          {description && (
            <Grid
              container
              spacing={16}
              justify="flex-start"
              className={classes.grayBG}
            >
              <Grid item xs={12}>
                <Typography className={[classes.titleText, classes.displayGrid].join(' ')}>
                  <span>Additional Description:</span>
                  <strong dangerouslySetInnerHTML={{ __html: `${description}` }}></strong>
                </Typography>
              </Grid>
            </Grid>
          )}
        </ExpansionPanelSummary>

        <ExpansionPanelDetails className={classes.panelDetails}>{children}</ExpansionPanelDetails>
      </ExpansionPanel>
    );
  }
}

// @ts-ignore
export default withStyles(styles)(MyPATExpansionStep);
